






















































































import { Component, Vue, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";
import firebase from "firebase/app";
import "firebase/auth";
import * as M from "materialize-css";

const user = namespace("User");
@Component
export default class Interview extends Vue {
  @Prop({ default: "" })
  readonly oid!: string;
  @Prop({ default: "" })
  readonly iid!: string;
  @Prop({ default: "" })
  readonly name!: string;
  @Prop({ default: "" })
  readonly mode!: string;
  @Prop({ default: "red-pastel" })
  readonly color!: string;
  @Prop({ default: true })
  readonly available!: boolean;
}
